import { render } from "./Html.vue?vue&type=template&id=50677080&scoped=true"
import script from "./Html.vue?vue&type=script&lang=js"
export * from "./Html.vue?vue&type=script&lang=js"

import "./Html.vue?vue&type=style&index=0&id=50677080&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50677080"]])

export default __exports__